<template>
<div class='bto-sb-element'>
   <div class="bto-sb-event-horse"  v-for="(items,idx) in HRraces" :key="idx" >
    <div class="bto-sb-event-odds-nav" >
      <div class="bto-sb-event-odds-nav-labels">
        <div class="bto-sb-event-odds-left">
          <span class="bto-sb-flag bto-sb-flag-oval" :class="items.categoryCss"></span>
          <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">{{items.categoryName}}</div>
        </div>
        <div class="bto-sb-event-odds-right">
          <div class="bto-sb-event-odds-cell">
            <span class="bto-sb-event-marketlabel" v-for="(race) in races" :key="race">{{race}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bto-sb-event-odds-content" >
      <div class="bto-sb-event-odds" v-for="(item,idx) in items.categories" :key="idx" >
        <div class="bto-sb-event-odds-left">
          <div class="bto-sb-event-name">
            <a :title="item.tournamentName" @click="$emit('openDetails',item.tournamentId, 1)">
              <div class="bto-sb-event-wrap">
                <span class="bto-sb-event-team">
                  <span class="bto-sb-event-home">{{item.tournamentName}}</span>
                </span>
              </div>
            </a>
          </div>
        </div>
        <div class="bto-sb-event-odds-right"  >
          <div class="bto-sb-event-odds-cell" >
            <span v-for="(race,idx) in item.tournaments.slice(0,8).sort((a,b)=> a.raceNumber - b.raceNumber)" 
              @click="$emit('openDetails',race.tournamentId, race.raceNumber)" 
              :key="idx" class="bto-sb-event-odd" 
              :class="`${getIconStatusClass(race.raceStatusId)}`">
              {{race.time}}
            </span>
            <span v-for="item in races.slice(item.tournaments.length,8)" :key="item" class="bto-sb-event-odd">-:-</span>
          </div>
        </div>
      </div>
    </div>
   </div>
</div>
</template>

<script>
  import { HORSE_RACING_STATUSES_CLASES } from '../../../models/enums/horse-racing-const';

  export default {
    name: "TodayRacesHr",
    data() {
      return {
        races: [1, 2, 3, 4, 5, 6, 7, 8],
      };
    },
    props: {
      HRraces: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    methods: {
      getIconStatusClass(status) {
        return HORSE_RACING_STATUSES_CLASES[status] || '';
      },
    }
  };
</script>
